import { render, staticRenderFns } from "./BlogsTable.vue?vue&type=template&id=131e2f36&scoped=true"
import script from "./BlogsTable.vue?vue&type=script&lang=js"
export * from "./BlogsTable.vue?vue&type=script&lang=js"
import style0 from "./BlogsTable.vue?vue&type=style&index=0&id=131e2f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e2f36",
  null
  
)

export default component.exports